import locale from "./locales/en";
import { blockScreen } from "./common";
import { IConfirmProps } from "./types";
import { uid } from "@dhx/ts-common/core";

export function confirm(props: IConfirmProps) {
	props.buttonsAlignment = props.buttonsAlignment || "right";

	const apply = props.buttons && props.buttons[1] ? props.buttons[1] : locale.apply;
	const reject = props.buttons && props.buttons[0] ? props.buttons[0] : locale.reject;

	const unblock = blockScreen("dhx_alert__overlay-confirm " + (props.blockerCss || ""));

	return new Promise(res => {
		const confirmBox = document.createElement("div");
		confirmBox.setAttribute("role", "alertdialog");
		confirmBox.setAttribute("aria-modal", "true");
		const headerId = props.header && uid();
		const textId = props.header && uid();
		textId && confirmBox.setAttribute("aria-describedby", textId);
		headerId && confirmBox.setAttribute("aria-labelledby", headerId);
		let focusItem;
		const answer = val => {
			unblock();
			// eslint-disable-next-line @typescript-eslint/no-use-before-define
			confirmBox.removeEventListener("click", clickHandler);
			// eslint-disable-next-line @typescript-eslint/no-use-before-define
			document.removeEventListener("keydown", closeConfirm);
			document.body.removeChild(confirmBox);
			res(val);
		};

		const clickHandler = e => {
			if ((e.target as HTMLElement).tagName === "BUTTON") {
				answer((e.target as HTMLElement).classList.contains("dhx_alert__confirm-aply"));
			}
		};

		const closeConfirm = e => {
			if (e.key === "Escape" || e.key === "Esc") {
				(confirmBox.querySelector(".dhx_alert__confirm-aply") as HTMLElement).focus();
				answer((e.target as HTMLElement).classList.contains("dhx_alert__confirm-reject"));
			} else if (e.key === "Tab") {
				if (focusItem === "aply") {
					focusItem = "reject";
					(confirmBox.querySelector(".dhx_alert__confirm-reject") as HTMLElement).focus();
				} else {
					focusItem = "aply";
					(confirmBox.querySelector(".dhx_alert__confirm-aply") as HTMLElement).focus();
				}
				e.preventDefault();
			}
		};

		confirmBox.className = "dhx_widget dhx_alert dhx_alert--confirm" + (props.css ? " " + props.css : "");

		confirmBox.innerHTML = `
		${
			props.header
				? `<div class="dhx_alert__header" id=${headerId}> ${
						props.htmlEnable !== false ? props.header : ""
				  } </div>`
				: ""
		}
		${
			props.text
				? `<div class="dhx_alert__content" id=${textId}>${
						props.htmlEnable !== false ? props.text : ""
				  }</div>`
				: ``
		}
			<div class="dhx_alert__footer ${
				props.buttonsAlignment ? "dhx_alert__footer--" + props.buttonsAlignment : ""
			}">
				<button type="button" aria-label="reject" class="dhx_alert__confirm-reject dhx_button dhx_button--view_link dhx_button--color_primary dhx_button--size_medium">${reject}</button>
				<button type="button"  aria-label="aply"class="dhx_alert__confirm-aply dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium">${apply}</button>
			</div>`;

		if (props.htmlEnable === false) {
			props.header && (confirmBox.querySelector(`#${headerId}`).textContent = props.header);
			props.text && (confirmBox.querySelector(`#${textId}`).textContent = props.text);
		}

		document.body.appendChild(confirmBox);
		focusItem = "aply";
		(confirmBox.querySelector(".dhx_alert__confirm-aply") as HTMLElement).focus();

		confirmBox.addEventListener("click", clickHandler);
		document.addEventListener("keydown", closeConfirm);
	});
}
